import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";
import { ReactComponent as GoogleIcon } from "../../../assets/Icons/googleIcon.svg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getUser } from "../../../Redux/UserSlice/UserSlice";
import { getUserDetails } from "../../../Redux/UserDetailsSlice/UserDetailsSlice";
import { getAccessToken } from "../../../Redux/AToken/ATokenSlice";
import { getLanguageModal } from "../../../Redux/LanguageModal/languageModalSlice";
import { analytics2, authenticate, getUserSubscription } from "../../../network/service";
import * as loginService from "../Login/service";
import * as registerService from "../Register/service";
import { updateAccountdetails } from "../AccountSettings/service";
import { stripeSession, checkIfEmailExists, applyCouponCode, getAndroidSubscriptionDetails, getUpcomingInvoice, subscriptionUpdate, getVideoSubscription, cinetPayApiSession, squareSubscription, bogSubscription, getPlanDetails } from "../../Subscription/service";
import Translate, { useTranslateText } from "../../../Components/Multilanguage/Translate";
import { loadStripe } from "@stripe/stripe-js";
import OtpModal from "../../../Components/Modals/OtpModal";
import SocialAccountLoginModal from "../../../Components/Modals/SocialAccountLoginModal";
import LoginModal from "../../../Components/Modals/LoginModal/LoginModal";
import ApplePrivateLoginModal from "../../../Components/Modals/LoginModal/ApplePrivateLoginModal";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import PaypalButtonWrapper from "../../Subscription/PaypalButtonWrapper";
import { jwtDecode } from "jwt-decode";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

export const getCleanPrice = (val) => {
  if (val === null || val === undefined) return "";
  const str = String(val).replace(/,/g, "").trim();
  const match = str.match(/\d+(\.\d+)?/);
  return match ? match[0] : "";
};

const EyeIcon = ({ visible }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" style={{ width: "20px", height: "20px", display: "inline-block", verticalAlign: "middle" }}>
    {visible ? (
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.824 7.824L21 21m-2.208-2.208l-3.482-3.482m-4.2 1.08a3 3 0 11-4.2-4.2M19.5 12a7.5 7.5 0 01-14.25 0" />
    ) : (
      <>
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.644C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </>
    )}
  </svg>
);

const ClockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" style={{ width: "18px", height: "18px", display: "inline-block", verticalAlign: "middle" }}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
  </svg>
);

const UserIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ width: "24px", height: "24px", display: "inline-block", verticalAlign: "middle" }}
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const Checkout3 = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const translateText = useTranslateText();

  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const user = useSelector((state) => state?.user?.value);
  const userDetails = useSelector((state) => state?.userDetails?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);

  const isRealUser = userDetails && userDetails.user_id && !userDetails.is_guest;

  const appInfo = {
    accessToken: accessToken,
    projectDetails: projectInfo,
  };
  const isUpgradeFlow = location?.state?.type === "upgrade" && !!location?.state?.subId;
  const previousSubId = location?.state?.subId;
  const urlParams = new URLSearchParams(window.location.search);
  const checkoutPlanKey = location?.pathname?.split("/checkout/")?.[1];
  const videoId = location?.state?.videoId || urlParams.get("vd");
  const showId = location?.state?.showId;
  const channelId = location?.state?.channelId || urlParams.get("cn");
  const eventId = location?.state?.eventId || urlParams.get("ed");
  const videoVanity = urlParams.get("video");
  const showVanity = urlParams.get("show");
  const isVideoContext = !!(videoId || showId || channelId || eventId || videoVanity || showVanity || checkoutPlanKey);
  const redirectUrl = location?.state?.path || location?.state?.prevPath || "/home";

  const subscriber = projectInfo?.projectConfig?.config?.SUBSCRIBER_BENEFITS;
  const planFeatures = subscriber?.features || [];
  const gateways = Array.isArray(projectInfo?.projectConfig?.config?.WEBSITE_PAYMENT_GATEWAYS)
    ? projectInfo?.projectConfig?.config?.WEBSITE_PAYMENT_GATEWAYS
    : ["STRIPE"];

  const [selectedPlan, setSelectedPlan] = useState("");
  const [authTab, setAuthTab] = useState(
    (location?.state?.activeLogin || location?.state?.isLogin || window.location.pathname === "/login") ? "login" : "register"
  );
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [googleUser, setGoogleUser] = useState(null);
  const [activeUserSubIds, setActiveUserSubIds] = useState([]);
  const [haveCoupon, setHaveCoupon] = useState(false);
  const [couponCode, setCouponCode] = useState({ couponId: null, couponCode: null });
  const [couponSuccess, setCouponSuccess] = useState(false);
  const [couponProcessing, setCouponProcessing] = useState(false);
  const [couponError, setCouponError] = useState("");
  const [upgradeInvoiceDetails, setUpgradeInvoiceDetails] = useState(null);
  const [upgradeStripeDetails, setUpgradeStripeDetails] = useState(null);
  const [showUpgradeConfirm, setShowUpgradeConfirm] = useState(false);
  const [upgradeProcessing, setUpgradeProcessing] = useState(false);
  const [upgradePlans, setUpgradePlans] = useState([]);
  const [selectedUpgradePlanId, setSelectedUpgradePlanId] = useState(null);
  const [upgradeLoading, setUpgradeLoading] = useState(false);
  const [upgradeFailMessage, setUpgradeFailMessage] = useState("");
  const [videoSubscriptions, setVideoSubscriptions] = useState([]);
  const [selectedVideoPlanId, setSelectedVideoPlanId] = useState(null);
  const [activeSubscriptions, setActiveSubscriptions] = useState([]);
  const [hasExistingSubscription, setHasExistingSubscription] = useState(false);
  const [selectedGateway, setSelectedGateway] = useState(gateways[0] || "STRIPE");
  const [showPaypalContainer, setShowPaypalContainer] = useState(false);
  const [selectedSubscriptionData, setSelectedSubscriptionData] = useState({});
  const [showPhoneInput, setShowPhoneInput] = useState(false);
  const [phoneValue, setPhoneValue] = useState("");
  const [phoneRequiredMessage, setPhoneRequiredMessage] = useState("");
  const [pendingPaymentInfo, setPendingPaymentInfo] = useState(null);
  const [pendingGateway, setPendingGateway] = useState(null);
  const [otpModal, setOtpModal] = useState(false);
  const [userRegisterId, setUserRegisterId] = useState(null);
  const [checkoutValues, setCheckoutValues] = useState({});
  const [showSocialLoginModal, setShowSocialLoginModal] = useState(false);
  const [socialLoginModalType, setSocialLoginModalType] = useState({});
  const [emailLoginModal, setEmailLoginModal] = useState(false);
  const [applePrivateData, setApplePrivateData] = useState(null);
  const [applePrivateLogin, setApplePrivateLogin] = useState(false);
  const [applePrivateEmail, setApplePrivateEmail] = useState("");
  const [isVizio, setIsVizio] = useState(false);
  const [userSubscriptionRows, setUserSubscriptionRows] = useState([]);
  const [otpTriggeredBy, setOtpTriggeredBy] = useState(null);
  const [isRental, setIsRental] = useState(false);
  const [rentalCheckoutDetails, setRentalCheckoutDetails] = useState({});
  const [redirectCountdown, setRedirectCountdown] = useState(5);
  const [hidePlans, setHidePlans] = useState(false);

  useEffect(() => {
    const str = location?.state?.path;
    if (str && str.includes("?")) {
      // Split off the query part and parse it
      const params = new URLSearchParams(str.split("?")[1]);

      const hidePlans = params.get("hide_plans") === "true";
      setHidePlans(hidePlans);
    }
  }, [location?.state?.path]);

  useEffect(() => {
    if (isUpgradeFlow && previousSubId) {
      localStorage.setItem("previousSubId", previousSubId);
    }
  }, [isUpgradeFlow, previousSubId]);

  useEffect(() => {
    if (!isUpgradeFlow) {
      localStorage.removeItem("previousSubId");
    }
  }, [isUpgradeFlow]);

  useEffect(() => {
    if (!isVideoContext || isUpgradeFlow) return;

    const fetchSubscriptionList = async () => {
      try {
        let typeID = null;
        let typeName = null;

        if (eventId) {
          typeID = eventId;
          typeName = "event";
        } else if (videoId) {
          typeID = videoId;
          typeName = "video";
        } else if (showId) {
          typeID = showId;
          typeName = "show";
        } else if (videoVanity) {
          typeID = videoVanity;
          typeName = "video_vanity";
        } else if (showVanity) {
          typeID = showVanity;
          typeName = "show_vanity";
        } else if (channelId) {
          typeID = channelId;
          typeName = "channel";
        }

        if (checkoutPlanKey) {
          const planKeyResponse = await getPlanDetails(appInfo, checkoutPlanKey);
          if (planKeyResponse?.status === 200) {
            const keyedPlans = planKeyResponse?.data?.data || [];
            setVideoSubscriptions(keyedPlans);
            if (keyedPlans?.length > 0) {
              setSelectedVideoPlanId(keyedPlans[0]?.subscription_id);
              setSelectedSubscriptionData(keyedPlans[0]);
            }
          }
          return;
        }

        const response = await getVideoSubscription(
          appInfo,
          typeID,
          typeName,
          "list",
          null,
          location?.state?.is_go_ad_free,
          location?.state?.is_challenge
        );

        const activeResponse = await getVideoSubscription(appInfo, typeID, typeName);
        if (activeResponse?.status === 200) {
          const activeData = activeResponse?.data?.data || [];
          setActiveSubscriptions(activeData);
        }

        if (response?.status === 200) {
          const plans = response?.data?.data || [];
          setVideoSubscriptions(plans);
          if (plans.length > 0) {
            const incomingPlanId = location?.state?.subscriptionId;
            const initial = plans.find((p) => String(p?.subscription_id) === String(incomingPlanId)) || plans[0];
            setSelectedVideoPlanId(initial?.subscription_id);
            setSelectedSubscriptionData(initial);
          }
        }
      } catch (error) {
        console.error("Failed to fetch video subscription list", error);
      }
    };

    fetchSubscriptionList();
  }, [isVideoContext, isUpgradeFlow, checkoutPlanKey, eventId, videoId, showId, channelId, videoVanity, showVanity, location?.state?.subscriptionId]);

  const getResolvedPrevPath = () => {
    const savedPrev = sessionStorage.getItem("checkout_prevPath") || sessionStorage.getItem("lastDetailPath");
    return location?.state?.prevPath || location?.state?.path || location?.state?.backURL || savedPrev;
  };

  const executeBackNavigation = () => {
    const isGoAdFree = location?.state?.is_go_ad_free || sessionStorage.getItem("checkout_is_go_ad_free") === "true";
    const prevPath = getResolvedPrevPath();
    sessionStorage.removeItem("checkout_prevPath");
    sessionStorage.removeItem("checkout_is_go_ad_free");

    const isPlayerPath = prevPath?.includes("/video") || prevPath?.includes("/player") || prevPath?.includes("/live") || prevPath?.includes("/live-channels") || prevPath?.includes("/livestream");
    const allowPath = isGoAdFree || !isPlayerPath;

    const target = (prevPath && allowPath && prevPath !== window.location.pathname)
      ? prevPath
      : "/home";

    try {
      navigate(target, { replace: true });
      setTimeout(() => {
        if (window.location.pathname.includes("/checkout")) {
          window.location.replace(target);
        }
      }, 50);
    } catch (e) {
      window.location.replace(target);
    }
  };

  useEffect(() => {
    const currentPrev = location?.state?.prevPath || location?.state?.backURL;
    if (currentPrev) {
      sessionStorage.setItem("checkout_prevPath", currentPrev);
    }
    if (location?.state?.is_go_ad_free) {
      sessionStorage.setItem("checkout_is_go_ad_free", "true");
    }
    const fromState = location?.state?.from;
    if (fromState) {
      sessionStorage.setItem("checkout_from", fromState);
    }

    const handlePopState = () => {
      executeBackNavigation();
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [location?.state, navigate]);

  useEffect(() => {
    // console.log('location?.state', location?.state);

    if (location?.state?.isRental) {
      setIsRental(true);
      setRentalCheckoutDetails(location?.state?.checkoutDetails || {});
    }
  }, [location?.state?.isRental]);

  useEffect(() => {
    const subscribedSuccess = location?.state?.subscribedSuccess;
    const prevPath = location?.state?.prevPath;
    const returnedVideoId = location?.state?.videoId;
    if (subscribedSuccess && prevPath) {
      navigate(prevPath, { state: { episodeId: returnedVideoId } });
    }
  }, [location?.state, navigate]);

  useEffect(() => {
    if (projectInfo?.projectConfig?.config?.APPLE_LOGIN_REQUIRED !== "true" || !projectInfo?.projectConfig?.config?.APPLE_CLIENT_ID) {
      return;
    }

    const script = document.createElement("script");
    script.src = "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
    script.async = true;
    document.body.appendChild(script);

    const onSuccess = (event) => {
      const appleData = jwtDecode(event?.detail?.authorization?.id_token);
      if (appleData?.is_private_email === "true" && appleData?.sub) {
        setApplePrivateData(appleData);
        setApplePrivateLogin(true);
      } else if (appleData?.sub) {
        appleLoginWithGizmott(appleData);
      } else {
        toast.error(<Translate textKey={"try_again_msg"} />);
      }
    };

    const onFailure = (event) => {
      console.error("Apple Sign-in failed:", event?.detail?.error);
    };

    script.onload = () => {
      if (window.AppleID) {
        window.AppleID.auth.init({
          clientId: projectInfo?.projectConfig?.config?.APPLE_CLIENT_ID,
          scope: "email name",
          redirectURI: projectInfo?.projectConfig?.config?.APPLE_LOGIN_REDIRECT_URL,
          usePopup: true,
        });
        document.addEventListener("AppleIDSignInOnSuccess", onSuccess);
        document.addEventListener("AppleIDSignInOnFailure", onFailure);
      }
    };

    return () => {
      document.removeEventListener("AppleIDSignInOnSuccess", onSuccess);
      document.removeEventListener("AppleIDSignInOnFailure", onFailure);
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, [projectInfo?.projectConfig?.config?.APPLE_LOGIN_REQUIRED, projectInfo?.projectConfig?.config?.APPLE_CLIENT_ID, projectInfo?.projectConfig?.config?.APPLE_LOGIN_REDIRECT_URL]);

  useEffect(() => {
    if (applePrivateEmail && applePrivateData) {
      appleLoginWithGizmott({ ...applePrivateData, email: applePrivateEmail });
    }
  }, [applePrivateEmail, applePrivateData]);

  const fetchUpgradePlans = async () => {
    if (!previousSubId) return;
    setUpgradeLoading(true);
    try {
      const response = await getVideoSubscription(appInfo, previousSubId, null, 'list');
      if (response?.status === 200) {
        const plans = response?.data?.data || [];
        setUpgradePlans(plans);
        if (plans.length > 0) {
          setSelectedUpgradePlanId(plans[0]?.subscription_id);
        }
      }
    } catch (err) {
      console.error("Failed to fetch upgrade plans:", err);
    } finally {
      setUpgradeLoading(false);
    }
  };

  useEffect(() => {
    if (isUpgradeFlow && isRealUser) {
      fetchUpgradePlans();
    }
  }, [isUpgradeFlow, isRealUser]);

  useEffect(() => {
    try {
      const ref = new URLSearchParams(location.search || window.location.search).get('ref');
      if (ref && !couponCode?.couponCode) {
        setCouponCode({ couponCode: ref.trim() });
        setHaveCoupon(true);
      }
    } catch (e) {
      console.error("Error reading coupon from URL:", e);
    }
  }, [location.search]);

  const fetchAndroidSubscriptionDetails = async (androidToken, info) => {
    const data = {
      projectDetails: info,
      accessToken: accessToken,
    };
    try {
      const response = await getAndroidSubscriptionDetails(data, androidToken);
      if (response?.status === 200) {
        const userDetails = response?.data?.data[0];
        if (userDetails?.user_id) {
          localStorage.setItem("userId", userDetails?.user_id);
          localStorage.setItem("isAndroid", "true");
          localStorage.setItem("deviceType", "android-web");
          if (userDetails?.language?.short_code) {
            localStorage.setItem('selectedLanguageCode', userDetails.language.short_code);
          }
          if (userDetails?.language?.language_id) {
            localStorage.setItem('selectedLanguageId', userDetails.language.language_id);
          }

          const authRes = await authenticate(appInfo);
          if (authRes) {
            dispatch(getUser({ user: userDetails?.user_id }));
            dispatch(getUserDetails({ userDetails: authRes?.data ? authRes?.data : authRes }));
          }

          const url = new URL(window.location.href);
          const params = new URLSearchParams(url.search);
          params.delete('antkn');
          params.delete('deviceId');

          const newUrl = `${url.pathname}?${params.toString()}`;
          window.location.href = newUrl;
        }
      }
    } catch (err) {
      console.error("Error fetching android subscription details:", err);
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const androidToken = urlParams.get("antkn");
    if (androidToken && Object.keys(projectInfo || {}).length > 0) {
      fetchAndroidSubscriptionDetails(androidToken, projectInfo);
    }
  }, [projectInfo]);

  useEffect(() => {
    setCouponSuccess(false);
    setCouponError("");
    setCouponCode({ couponId: null, couponCode: null });
    setHaveCoupon(false);
    localStorage.removeItem("couponId");
  }, [selectedPlan, selectedVideoPlanId]);

  useEffect(() => {
    const activeLogin = location?.state?.activeLogin;
    const isNewLogin = new URLSearchParams(window.location.search).get("new-login") === "1";
    if (isNewLogin) {
      setAuthTab("login");
      return;
    }
    if (activeLogin === true) {
      setAuthTab("login");
    } else if (activeLogin === false) {
      setAuthTab("register");
    } else {
      if (window.location.pathname === "/login" || location?.state?.isLogin) {
        setAuthTab("login");
      } else if (window.location.pathname === "/register") {
        setAuthTab("register");
      }
    }
  }, [location]);

  useEffect(() => {
    if (!gateways?.length) return;
    setSelectedGateway((prev) => (gateways.includes(prev) ? prev : gateways[0]));
  }, [projectInfo?.projectConfig?.config?.WEBSITE_PAYMENT_GATEWAYS]);

  const benefits = (subscriber?.benefits || []).map(b => ({
    ...b,
    db_subscription_id: b.subscription_id || b.id,
    db_price: b.price,
  }));
  const activeSubIdSet = new Set((activeUserSubIds || []).map((id) => String(id)));
  const currentPlanDetails =
    benefits.find((b) => activeSubIdSet.has(String(b?.db_subscription_id))) ||
    (isRealUser ? benefits.find((b) => b.id === "free") : null) ||
    null;
  const currentPlanId = currentPlanDetails?.id;
  const planTierOrder = { free: 0, monthly: 1, annual: 2 };
  const currentPlanTier = planTierOrder[currentPlanId] ?? -1;

  const visibleBenefits = benefits.filter((b) => {
    if (currentPlanId === "annual") {
      return b?.id === "annual" || b?.id === "monthly";
    }
    if ((user || isRealUser) && b?.id === "free") {
      return false;
    }
    if (currentPlanTier > 0 && b?.id === "free") {
      return false;
    }
    return true;
  });

  const selectedPlanDetails = benefits.find(b => b.id === selectedPlan) || null;
  const filteredVideoPlans = (videoSubscriptions || []).filter((plan) => {
    const typeId = Number(plan?.subscription_type_id);
    if (isRental === true) {
      return typeId !== 3 && typeId !== 4;
    }
    return typeId === 3 || typeId === 4;
  });
  const selectedVideoPlan =
    filteredVideoPlans.find((item) => String(item?.subscription_id) === String(selectedVideoPlanId)) ||
    filteredVideoPlans[0];
  const useVideoPlanSelection = isVideoContext && !isUpgradeFlow && isRental;
  const selectedCheckoutPlan = useVideoPlanSelection ? selectedVideoPlan : selectedPlanDetails;
  const hasSelectedCheckoutPlan = !!selectedCheckoutPlan;

  useEffect(() => {
    if (!isVideoContext || isUpgradeFlow) return;

    if (!filteredVideoPlans.length) {
      setSelectedVideoPlanId(null);
      setSelectedSubscriptionData({});
      return;
    }

    const matchingPlan = filteredVideoPlans.find(
      (item) => String(item?.subscription_id) === String(selectedVideoPlanId)
    );
    const initialPlan =
      matchingPlan ||
      filteredVideoPlans.find(
        (item) => String(item?.subscription_id) === String(location?.state?.subscriptionId)
      ) ||
      filteredVideoPlans[0];

    if (String(selectedVideoPlanId) !== String(initialPlan?.subscription_id)) {
      setSelectedVideoPlanId(initialPlan?.subscription_id ?? null);
    }

    if (initialPlan?.subscription_id) {
      setSelectedSubscriptionData(initialPlan);
    }
  }, [
    filteredVideoPlans,
    isVideoContext,
    isUpgradeFlow,
    selectedVideoPlanId,
    location?.state?.subscriptionId,
  ]);

  useEffect(() => {
    const fetchUserSubs = async () => {
      if (user || userDetails) {
        try {
          const res = await getUserSubscription(appInfo);
          if (res?.status === 200) {
            const subs = res?.data?.data || [];
            const subIds = subs.map(s => s.sub_id);
            setActiveUserSubIds(subIds);
            setUserSubscriptionRows(subs);
            setIsVizio((subs?.[0]?.mode_of_payment || "").toLowerCase() === "vizio");
          }
        } catch (err) {
          console.error("Failed to fetch user subscriptions:", err);
        }
      } else {
        setActiveUserSubIds([]);
        setUserSubscriptionRows([]);
        setIsVizio(false);
      }
    };
    fetchUserSubs();
  }, [user, userDetails]);

  useEffect(() => {
    if (!isRealUser || activeSubscriptions.length === 0 || userSubscriptionRows.length === 0) {
      setHasExistingSubscription(false);
      return;
    }
    const hasMatchingSub = userSubscriptionRows.some((userSub) =>
      activeSubscriptions.some((activeSub) => userSub?.sub_id === activeSub?.subscription_id)
    );
    setHasExistingSubscription(hasMatchingSub);
  }, [isRealUser, activeSubscriptions, userSubscriptionRows]);

  useEffect(() => {
    if ((hasExistingSubscription === true || videoSubscriptions.length === 0) && isVideoContext && !isUpgradeFlow) {
      setRedirectCountdown(5);
      const interval = setInterval(() => {
        setRedirectCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            navigate(redirectUrl || "/", { state: { episodeId: videoId } });
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [hasExistingSubscription, videoSubscriptions, isVideoContext, isUpgradeFlow, redirectUrl, videoId, navigate]);

  useEffect(() => {
    if (visibleBenefits && visibleBenefits.length > 0) {
      const isCurrentValidAndVisible = visibleBenefits.some(b => b.id === selectedPlan);
      if (!selectedPlan || !isCurrentValidAndVisible) {
        const selectablePlan = visibleBenefits.find(b => {
          const isSubscribed = b.requires_payment && activeUserSubIds.includes(b.db_subscription_id);
          const isFreeAndLoggedIn = !b.requires_payment && (user || isRealUser);
          const isCurrentUpgradePlan = isUpgradeFlow && String(b.db_subscription_id) === String(previousSubId);
          return !isSubscribed && !isFreeAndLoggedIn && !isCurrentUpgradePlan;
        });

        const defaultPlan = selectablePlan || visibleBenefits[0];
        if (defaultPlan && defaultPlan.id) {
          setSelectedPlan(defaultPlan.id);
          localStorage.setItem("selectedSubId", defaultPlan.db_subscription_id || defaultPlan.id);
          localStorage.setItem("selectedAmount", getCleanPrice(defaultPlan.db_price || defaultPlan.price));
          localStorage.setItem("deviceType", localStorage.getItem("isAndroid") === "true" ? "android-web" : "web");
        }
      }
    }
  }, [visibleBenefits, selectedPlan, activeUserSubIds, user, isRealUser, isUpgradeFlow, previousSubId]);

  const openUpgradeConfirmation = async () => {
    const plan = upgradePlans.find(p => p.subscription_id === selectedUpgradePlanId);
    if (!plan?.subscription_id) {
      setUpgradeFailMessage(translateText("try_again_msg"));
      return;
    }

    const payload = {
      subscription_id: plan.subscription_id,
      price: plan.price,
    };

    setUpgradeFailMessage("");
    setUpgradeProcessing(true);
    try {
      const invoiceResponse = await getUpcomingInvoice(payload, appInfo);
      if (invoiceResponse?.status === 200 && invoiceResponse?.data?.success) {
        const paymentDetails = invoiceResponse?.data?.data || {};
        const {
          amount_due,
          unused_time,
          plan_amount,
          description,
        } = paymentDetails;
        setUpgradeInvoiceDetails({
          due: amount_due,
          discount: unused_time,
          plan: plan_amount,
          description,
        });
      } else {
        setUpgradeFailMessage(invoiceResponse?.data?.message || "");
        return;
      }

      setUpgradeStripeDetails(payload);
      localStorage.setItem("selectedSubId", String(plan.subscription_id));
      setShowUpgradeConfirm(true);
    } catch (err) {
      setUpgradeFailMessage(err?.response?.data?.message || err?.message || translateText("try_again_msg"));
    } finally {
      setUpgradeProcessing(false);
    }
  };

  const confirmUpgrade = async () => {
    if (!upgradeStripeDetails) return;

    setUpgradeProcessing(true);
    try {
      const updateResponse = await subscriptionUpdate(upgradeStripeDetails, appInfo);
      if (updateResponse?.status !== 200) {
        toast.error(updateResponse?.data?.message || translateText("try_again_msg"));
        return;
      }

      const stripeData = updateResponse?.data || {};

      if (stripeData?.requires_action) {
        const stripe = await loadStripe(stripeData?.access_key);
        const stripePayment = await stripe?.confirmCardPayment(stripeData?.client_secret);

        if (stripePayment?.error) {
          toast.error(stripePayment?.error?.message || translateText("try_again_msg"));
          return;
        }

        if (stripePayment?.paymentIntent?.status === "succeeded") {
          const authenticatedResponse = await subscriptionUpdate(upgradeStripeDetails, appInfo, true);
          if (authenticatedResponse?.status !== 200) {
            toast.error(authenticatedResponse?.data?.message || translateText("try_again_msg"));
            return;
          }
        }
      } else if (!stripeData?.success) {
        toast.error(stripeData?.message || translateText("try_again_msg"));
        return;
      }

      toast.success(<Translate textKey={"payment_success_message"} />);
      setShowUpgradeConfirm(false);
      navigate("/account");
    } catch (err) {
      toast.error(err?.message || err?.response?.data?.message || translateText("try_again_msg"));
    } finally {
      setUpgradeProcessing(false);
    }
  };

  const tokenAuthenticate = async () => {
    const response = await authenticate(appInfo);
    if (response?.status === 200 || response?.token || response?.data?.token) {
      const authData = response?.data ? response?.data : response;
      localStorage.setItem("selectedLanguageCode", authData?.user_language?.short_code || "");
      localStorage.setItem("selectedLanguageId", authData?.user_language?.language_id || "");
      dispatch(getLanguageModal({ languageModal: { selectedLanguageCode: authData?.user_language?.short_code } }));
      dispatch(getAccessToken({ accessToken: authData?.token }));
      dispatch(getUserDetails({ userDetails: authData }));
      return authData;
    }
    return null;
  };

  const updateDeviceAnalytics = async (userId, info, userEmail, firstName = "") => {
    try {
      await analytics2(userId, info, userEmail, firstName);
    } catch (error) {
      console.error("analytics2 failed", error);
    }
  };

  const switchToAnotherAccount = () => {
    localStorage.clear();
    dispatch(getUser({ user: null }));
    const nextUrl = window.location.href.includes("new-login=1") ? window.location.href : `${window.location.href}${window.location.href.includes("?") ? "&" : "?"}new-login=1`;
    window.location.href = nextUrl;
  };

  const loginWithoutCode = async (values) => {
    try {
      const response = await loginService.updateLoginWithoutCode(appInfo, values);
      if (response?.status === 200) {
        const userData = response?.data?.data?.[0];
        localStorage.setItem("userId", userData?.user_id);
        dispatch(getUser({ user: userData?.user_id }));
        await tokenAuthenticate();
        await updateDeviceAnalytics(userData?.user_id, appInfo, userData?.user_email || values?.email, userData?.first_name || values?.firstName);
        if (values?.loginType === "google") {
          window.location.replace(redirectUrl || "/checkout");
          return;
        }
        if (values?.loginType === "apple") {
          if (selectedPlan !== 0) {
            window.location.replace(redirectUrl || "/home");
          } else {
            window.location.replace(redirectUrl || "/checkout");
          }
          return;
        }
        navigate(redirectUrl || "/home", { state: location?.state });
      } else if (response?.status === 204) {
        setSocialLoginModalType({
          heading: response?.data?.message,
          values,
        });
        setShowSocialLoginModal(true);
      } else {
        toast.error(response?.data?.message || translateText("try_again_msg"));
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || translateText("try_again_msg"));
    }
  };

  const appleLoginWithGizmott = (appleData) => {
    const email = appleData?.email;
    const name = email?.split("@")[0] || "Apple User";
    loginWithoutCode({
      appleId: appleData?.sub,
      loginType: "apple",
      firstName: name,
      email,
    });
  };

  const runGatewayPayment = async (gatewayName, paymentInfo, planObj) => {
    const normalizedGateway = (gatewayName || "STRIPE").toUpperCase();
    setPendingGateway(normalizedGateway);
    setPendingPaymentInfo(paymentInfo);

    if (normalizedGateway === "PAYPAL") {
      setSelectedSubscriptionData(planObj || {});
      setShowPaypalContainer(true);
      return;
    }

    if (normalizedGateway === "IDEABIZ") {
      localStorage.setItem("selectedAmount", getCleanPrice(planObj?.price));
      navigate("/ideabiz", {
        state: { subscription: planObj, appInfo },
      });
      return;
    }

    try {
      if (normalizedGateway === "CINETPAY") {
        const response = await cinetPayApiSession(appInfo, paymentInfo);
        const url = response?.data?.data?.url || response?.data?.url;
        if (url) window.open(url, "_self");
        return;
      }

      if (normalizedGateway === "SQUARE") {
        const response = await squareSubscription(appInfo, paymentInfo);
        const url = response?.data?.data?.url || response?.data?.url;
        if (url) window.open(url, "_self");
        return;
      }

      if (normalizedGateway === "BOG") {
        const response = await bogSubscription(appInfo, paymentInfo);
        const url = response?.data?.data?.redirect_url || response?.data?.redirect_url;
        if (url) {
          localStorage.setItem("bogOrderId", response?.data?.data?.order_id);
          window.open(url, "_self");
        }
        return;
      }

      const stripeResponse = await stripeSession(appInfo, paymentInfo);
      if (stripeResponse?.status === 200 && stripeResponse?.data?.url) {
        window.open(stripeResponse?.data?.url, "_self");
        return;
      }
      if (stripeResponse?.info === "PHONE_REQUIRED") {
        setShowPhoneInput(true);
        setPhoneRequiredMessage(stripeResponse?.message || translateText("enter_valid_phone_number"));
        return;
      }
      toast.error(stripeResponse?.data?.message || stripeResponse?.message || translateText("try_again_msg"));
    } catch (err) {
      if (err?.response?.data?.info === "PHONE_REQUIRED") {
        setShowPhoneInput(true);
        setPhoneRequiredMessage(err?.response?.data?.message || translateText("enter_valid_phone_number"));
        return;
      }
      toast.error(err?.response?.data?.message || translateText("try_again_msg"));
    }
  };

  const updatePhoneAndRetry = async () => {
    if (!phoneValue || phoneValue.trim() === "") {
      toast.error(<Translate textKey={"enter_valid_phone_number"} />);
      return;
    }
    const formatted = phoneValue.startsWith("+") ? phoneValue : `+${phoneValue}`;
    try {
      const response = await updateAccountdetails(appInfo, { phone: formatted });
      if (response?.data?.success === true) {
        setShowPhoneInput(false);
        setPhoneRequiredMessage("");
        if (pendingPaymentInfo) {
          const planObj = (useVideoPlanSelection
            ? videoSubscriptions.find((p) => String(p?.subscription_id) === String(selectedVideoPlanId))
            : selectedPlanDetails) || {};
          await runGatewayPayment(pendingGateway || selectedGateway, pendingPaymentInfo, planObj);
        }
      } else {
        toast.error(response?.data?.message || translateText("try_again_msg"));
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || translateText("try_again_msg"));
    }
  };

  const handleEmailCheck = async () => {
    if (!email) return;
    const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    if (!email.match(emailRegex)) return;

    try {
      const response = await checkIfEmailExists(appInfo, { user_email: email });
      if (response?.status === 201) {
        if (authTab === "register") {
          setAuthTab("login");
        }
      } else if (response?.status === 200) {
        if (authTab === "login") {
          setAuthTab("register");
        }
      }
    } catch (err) {
      console.error("Failed to check email existence: ", err);
    }
  };

  const handleProceedPaymentForPlan = async (plan) => {
    if (!plan) return;

    if (isUpgradeFlow) {
      await openUpgradeConfirmation();
      return;
    }

    if (plan.requires_payment === false || plan?.subscription_id === 0 || plan?.id === 0) {
      navigate(redirectUrl);
      return;
    }

    setIsProcessing(true);
    try {
      const paymentInfo = {
        subId: isRental
          ? rentalCheckoutDetails?.rental_checkout_plan_id
          : (useVideoPlanSelection ? plan?.subscription_id : plan?.db_subscription_id ?? plan?.subscription_id),
        couponId: couponCode?.couponId,
      };
      await runGatewayPayment(selectedGateway, paymentInfo, plan);
    } catch (err) {
      toast.error(err?.response?.data?.message);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleSelectPlan = (planId) => {
    const plan = benefits.find(b => b.id === planId);
    if (!plan) return;

    const isSubscribed = plan.requires_payment && activeUserSubIds.includes(plan.db_subscription_id);
    const isFreeAndLoggedIn = !plan.requires_payment && (user || isRealUser);
    const isCurrentUpgradePlan = isUpgradeFlow && String(plan.db_subscription_id) === String(previousSubId);

    if (isSubscribed || isFreeAndLoggedIn || isCurrentUpgradePlan) {
      return;
    }

    setSelectedPlan(planId);
    localStorage.setItem("selectedSubId", plan.db_subscription_id || planId);
    localStorage.setItem("selectedAmount", getCleanPrice(plan.db_price || plan.price));
    localStorage.setItem("deviceType", localStorage.getItem("isAndroid") === "true" ? "android-web" : "web");
  };

  const handleSelectVideoPlan = (subId) => {
    setSelectedVideoPlanId(subId);
    const plan = filteredVideoPlans.find((item) => String(item?.subscription_id) === String(subId));
    if (plan) {
      setSelectedSubscriptionData(plan);
      localStorage.setItem("selectedSubId", plan.subscription_id);
      localStorage.setItem("selectedAmount", getCleanPrice(plan.price));
      localStorage.setItem("deviceType", localStorage.getItem("isAndroid") === "true" ? "android-web" : "web");
    }
  };

  const googleLoginHandler = useGoogleLogin({
    onSuccess: (codeResponse) => setGoogleUser(codeResponse),
    onError: (error) => { console.error("Google Auth failed:", error); },
  });

  const getGoogleUserData = async () => {
    setIsProcessing(true);
    try {
      const response = await loginService.googleLogin(googleUser?.access_token);
      if (response?.status === 200) {
        const values = {
          googleId: response?.data?.id,
          loginType: "google",
          firstName: response?.data?.name,
          email: response?.data?.email,
        };
        await loginWithoutCode(values);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
    }
    setIsProcessing(false);
  };

  useEffect(() => {
    if (googleUser) {
      getGoogleUserData();
    }
  }, [googleUser]);

  const handleAuthSubmit = async (e) => {
    e.preventDefault();

    let isRegisterSuccess = false;
    let registerResponseMessage = "";
    if (authTab === "register") {
      if (password !== confirmPassword) {
        toast.error(<Translate textKey="password_not_matching_message" />);
        return;
      }
      setIsProcessing(true);
      try {
        const regVals = {
          email: email,
          password: password,
        };
        const response = await registerService.registerUser(appInfo, regVals);
        if (response?.status === 200) {
          registerResponseMessage = response?.data?.message || "";
          localStorage.setItem("userId", response?.data?.data[0]?.user_id);
          dispatch(getUser({ user: response?.data?.data[0]?.user_id }));
          const authRes = await tokenAuthenticate();
          if (authRes) {
            isRegisterSuccess = true;
            await updateDeviceAnalytics(
              response?.data?.data[0]?.user_id,
              appInfo,
              response?.data?.data?.[0]?.user_email || email,
              response?.data?.data?.[0]?.first_name || ""
            );
          }
        } else if (response?.status === 201) {
          setUserRegisterId(response?.data?.user_id || response?.data?.userId);
          setCheckoutValues({ email, password });
          setOtpTriggeredBy("register");
          setOtpModal(true);
        } else {
          toast.error(response?.data?.message);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message);
      }
      setIsProcessing(false);
    } else {
      setIsProcessing(true);
      try {
        const logVals = { email: email, password: password };
        const response = await loginService.login(logVals, appInfo);
        if (response?.status === 200) {
          localStorage.setItem("userId", response?.data?.data[0]?.user_id);
          dispatch(getUser({ user: response?.data?.data[0]?.user_id }));
          const authRes = await tokenAuthenticate();
          if (authRes) {
            await updateDeviceAnalytics(
              response?.data?.data[0]?.user_id,
              appInfo,
              response?.data?.data?.[0]?.user_email || email,
              response?.data?.data?.[0]?.first_name || ""
            );
          }
          setIsProcessing(false);
          if (!currentPlanDetails?.db_subscription_id && !isVideoContext) {
            const redirectpath = redirectUrl ? redirectUrl : "/home";
            navigate(redirectpath);
          }

          return;
        } else if (response?.status === 201) {
          setUserRegisterId(response?.data?.user_id || response?.data?.userId);
          setCheckoutValues({ email, password });
          setOtpTriggeredBy("login");
          setOtpModal(true);
        } else if (response?.status === 202) {
          toast.error(response?.data?.message || translateText("reset_password"));
        } else {
          toast.error(response?.data?.message);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message);
      }
      setIsProcessing(false);
    }

    if (isRegisterSuccess) {
      if ((selectedCheckoutPlan?.requires_payment === false || selectedCheckoutPlan?.subscription_id === 0 || selectedCheckoutPlan?.id === 0) && redirectUrl) {
        if (registerResponseMessage) toast.success(registerResponseMessage);
        navigate(redirectUrl);
      } else if (selectedCheckoutPlan) {
        handleProceedPaymentForPlan(selectedCheckoutPlan);
      }
    }

  };

  const renderPlansTable = () => {
    // if (isVideoContext && !isUpgradeFlow) {
    // return (
    //   <div className="plans-table-card video-plan-card">
    //     <div className="plans-card-header-label"><Translate textKey="choose_plan_caps" /></div>
    //     <div className="video-plans-list">
    //       {videoSubscriptions.length === 0 ? (
    //         <div className="video-plan-item empty-state">
    //           <p><Translate textKey="subscription_fetch" /></p>
    //         </div>
    //       ) : (
    //         videoSubscriptions.map((plan) => (
    //           <div
    //             key={plan?.subscription_id}
    //             className={`video-plan-item ${String(selectedVideoPlanId) === String(plan?.subscription_id) ? "active" : ""}`}
    //             onClick={() => handleSelectVideoPlan(plan?.subscription_id)}
    //           >
    //             <div className="content">
    //               <h4>{plan?.subscription_name}</h4>
    //               <p>{plan?.subscription_text || plan?.price}</p>
    //               {plan?.description && <span>{plan?.description}</span>}
    //             </div>
    //             <div className="selector">
    //               <span className={`radio ${String(selectedVideoPlanId) === String(plan?.subscription_id) ? "selected" : ""}`}></span>
    //             </div>
    //           </div>
    //         ))
    //       )}
    //     </div>
    //   </div>
    // );
    // }

    return (
      <div className="plans-table-card">
        <div className="plans-card-header-label"><Translate textKey="choose_plan_caps" /></div>

        <div className="plans-container">
          <div className="plans-intro-alert">
            <span className="icon-clock"><ClockIcon /></span>
            <p dangerouslySetInnerHTML={{ __html: translateText("checkout_alert_text") }} />
          </div>

          <div className="plans-grid">
            <div className="features-column">
              <div className="plan-badge empty">&nbsp;</div>
              <div className="header-cell empty-cell"><Translate textKey="choose_plan_caps" /></div>
              {planFeatures.map((f, i) => (
                <div key={i} className="feature-label-cell">
                  {f.title}
                </div>
              ))}
            </div>

            {visibleBenefits.map((b, i) => {
                const isSubscribed = b.requires_payment && activeUserSubIds.includes(b.db_subscription_id);
                const isFreeAndLoggedIn = !b.requires_payment && (user || isRealUser);
                const isCurrentUpgradePlan = isUpgradeFlow && String(b.db_subscription_id) === String(previousSubId);
                const planTier = planTierOrder[b?.id] ?? -1;
                const isCurrentPlan = currentPlanId === b?.id;
                const isLowerOrSameTierThanCurrent = currentPlanTier >= 0 && planTier <= currentPlanTier && !isCurrentPlan && !(currentPlanId === "annual" && b?.id === "monthly");
                const shouldShowSelect = !isSubscribed && !isFreeAndLoggedIn && !isCurrentUpgradePlan && !isLowerOrSameTierThanCurrent;
                const shouldShowUpgradeLabel = currentPlanTier >= 0 && planTier > currentPlanTier && shouldShowSelect;
                console.log('plans', b, user);

                return (
                  <div
                    key={i}
                    className={`plan-column ${b.requires_payment ? "highlighted-col" : ""} ${selectedPlan === b.id ? "active" : ""} ${!shouldShowSelect ? "disabled-col" : ""}`}
                    onClick={() => handleSelectPlan(b.id)}
                    style={!shouldShowSelect ? { cursor: "default", opacity: 0.85 } : undefined}
                  >
                    <div className={`plan-badge ${!b.requires_payment ? "empty" : ""}`}>{b.requires_payment ? "PLUS" : <>&nbsp;</>}</div>
                    <div className="header-cell">
                      <span className="plan-name">{b.title}</span>
                      <div className="plan-strike-slot">
                        {b.original_price ? <span className="strike-price">{b.original_price}</span> : <>&nbsp;</>}
                      </div>
                      <span className="plan-price">{b.db_price}</span>
                      <div className="plan-subtext-slot">
                        {b.subtext && (
                          b.subtext.toLowerCase().includes("save")
                            ? <div className="save-badge">{b.subtext}</div>
                            : b.subtext
                        )}
                      </div>
                    </div>
                    {planFeatures.map((f, fi) => (
                      <div key={fi} className="feature-value-cell">
                        <span className="mobile-feature-label">{f.title}</span>
                        {b.features?.some(x => x.id === f.id) ? <span className="check">✓</span> : <span className="dash">—</span>}
                      </div>
                    ))}
                    <div className="button-cell">
                      {shouldShowSelect ? (
                        <button className={`select-btn ${selectedPlan === b.id ? "selected" : ""}`}>
                          {shouldShowUpgradeLabel
                            ? "UPGRADE"
                            : selectedPlan === b.id
                              ? <Translate textKey="selected" />
                              : <Translate textKey="select" />}
                        </button>
                      ) : (
                        <span className="subscribed-label">{isCurrentPlan ?
                          <button className="select-btn selected current">
                            CURRENT
                          </button> : isCurrentUpgradePlan ? <Translate textKey="your_plan" /> : <>&nbsp;</>}</span>
                      )}
                      {/* {<span>{b.db_subscription_id}</span>} */}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    );
  };

  const applyCouponCodeHandler = async () => {
    if (!couponCode?.couponCode) {
      setCouponError(translateText("enter_coupon_code"));
      return;
    }

    setCouponProcessing(true);
    setCouponError("");
    try {
      const response = await applyCouponCode(
        appInfo,
        couponCode.couponCode,
        selectedCheckoutPlan?.subscription_id || selectedCheckoutPlan?.db_subscription_id || selectedPlan
      );

      if (response?.status === 200) {
        setCouponSuccess(true);
        localStorage.setItem("couponId", response?.data?.data?.coupon_id);
        setCouponCode(prev => ({
          ...prev,
          couponId: response?.data?.data?.coupon_id,
        }));
      } else {
        setCouponSuccess(false);
        setCouponError(response?.data?.message || "Invalid coupon code");
      }
    } catch (err) {
      setCouponSuccess(false);
      setCouponError("Invalid coupon code");
    } finally {
      setCouponProcessing(false);
    }
  };

  const renderAuthWidget = () => {
    const activePlan = selectedCheckoutPlan;
    const emailPrefix = (userDetails?.user_email || userDetails?.email)?.split('@')[0];
    const hasRealName = userDetails?.first_name && userDetails.first_name !== emailPrefix;
    const lastNamePart = userDetails?.last_name || "";
    const displayName = hasRealName
      ? `${userDetails.first_name} ${lastNamePart}`.trim()
      : (userDetails?.user_email || userDetails?.email || user);

    if (isRealUser) {
      return (
        <div className={`auth-widget-card user-dashboard ${isRental ? "rental-auth-widget-adjust" : ""}`}>
          <div className="user-profile-header">
            <div className="user-icon-circle">
              {userDetails?.user_image ? (
                <img src={userDetails.user_image} alt="Profile" className="user-avatar-img" />
              ) : (
                <UserIcon />
              )}
            </div>
            <h3>{displayName}</h3>
            {hasRealName && <p className="user-email">{userDetails?.user_email || userDetails?.email}</p>}
          </div>

          <hr className="divider" />

          <div className="dashboard-content">
            {isVizio && (
              <p className="upgrade-fail-msg">
                <Translate textKey={"vizio_subscription_message"} />
              </p>
            )}
            {hasExistingSubscription && isVideoContext && !isUpgradeFlow ? (
              <div className="access-already-card">
                <div className="access-icon-wrapper">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </div>
                <h3 className="access-title">You have access already!</h3>
                <p className="access-subtext">
                  No need to rent. Redirecting you to your video in <span className="countdown-number">{redirectCountdown}s</span>...
                </p>
                <button
                  type="button"
                  className="auth-submit-btn access-watch-btn"
                  onClick={() => navigate(redirectUrl || "/", { state: { episodeId: videoId } })}
                >
                  <Translate textKey="watch_now" />
                </button>
              </div>
            ) : null}
            {isUpgradeFlow ? (
              <>
                {upgradeLoading ? (
                  <p className="info-text" style={{ textAlign: "center" }}><Translate textKey="loading" /></p>
                ) : upgradePlans.length === 0 ? (
                  <p className="info-text" style={{ textAlign: "center" }}><Translate textKey="no_upgrade_available" /></p>
                ) : (
                  <div className="upgrade-plans-list">
                    {upgradePlans.map((plan) => (
                      <div
                        key={plan.subscription_id}
                        className={`upgrade-plan-item ${selectedUpgradePlanId === plan.subscription_id ? "selected" : ""}`}
                        onClick={() => { setSelectedUpgradePlanId(plan.subscription_id); setUpgradeFailMessage(""); }}
                      >
                        <div className="upgrade-plan-info">
                          <span className="upgrade-plan-name">{plan.subscription_name}</span>
                          <span className="upgrade-plan-price">{plan.subscription_text || plan.price}</span>
                        </div>
                        <div className="upgrade-plan-radio">
                          <div className={`radio-dot ${selectedUpgradePlanId === plan.subscription_id ? "active" : ""}`}></div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {upgradeFailMessage && (
                  <p className="upgrade-fail-msg">{upgradeFailMessage}</p>
                )}
                <button
                  className="auth-submit-btn"
                  disabled={upgradeProcessing || upgradeLoading || upgradePlans.length === 0}
                  onClick={openUpgradeConfirmation}
                >
                  {upgradeProcessing ? <Translate textKey="processing" /> : <Translate textKey="update" />}
                </button>
              </>
            ) : (
              <>
                {!isRental && hasSelectedCheckoutPlan ? (
                  <>
                    <div className={isVideoContext ? "pricing-summary video-context-summary" : "pricing-summary"}>
                      <span>{activePlan?.title || activePlan?.subscription_name || "Plan"}</span>
                      <strong>{activePlan?.db_price || activePlan?.subscription_text || activePlan?.price}</strong>
                    </div>
                    {activePlan?.description && (
                      <p className="info-text">
                        {activePlan.description}
                      </p>
                    )}
                  </>
                ) : !isRental && (
                  <p className="info-text" style={{ textAlign: "center" }}>
                    {/* <Translate textKey="subscription_fetch" /> */}
                    Please select a plan to continue.
                  </p>
                )}

                {gateways?.length > 1 && !isVizio && (
                  <div className="gateway-chip-group">
                    {gateways.map((gateway) => (
                      <button
                        key={gateway}
                        type="button"
                        className={`gateway-chip ${selectedGateway === gateway ? "active" : ""}`}
                        onClick={() => {
                          setSelectedGateway(gateway);
                          setShowPaypalContainer(false);
                        }}
                      >
                        {gateway}
                      </button>
                    ))}
                  </div>
                )}

                <button
                  className="auth-submit-btn"
                  disabled={isProcessing || isVizio || hasExistingSubscription || !hasSelectedCheckoutPlan}
                  onClick={() => handleProceedPaymentForPlan(activePlan)}
                >
                  {isProcessing ? <Translate textKey="processing" /> : (
                    activePlan?.requires_payment === false || activePlan?.subscription_id === 0 || activePlan?.id === 0
                      ? <Translate textKey="start_free_plan" />
                      : <Translate textKey="continue" />
                  )}
                </button>

                {selectedGateway === "PAYPAL" && showPaypalContainer && selectedSubscriptionData?.subscription_id && (
                  <div className="paypal-container-inline">
                    <PayPalScriptProvider
                      options={{
                        "client-id": projectInfo?.projectConfig?.config?.PAYPAL_CLIENT_ID,
                        components: "buttons",
                        currency: selectedSubscriptionData?.currency,
                        vault: true,
                        intent:
                          selectedSubscriptionData?.subscription_type_id === 3 ||
                            selectedSubscriptionData?.subscription_type_id === 4
                            ? "subscription"
                            : "capture",
                      }}
                    >
                      <PaypalButtonWrapper subscriptionData={selectedSubscriptionData} />
                    </PayPalScriptProvider>
                  </div>
                )}

                {showPhoneInput && (
                  <div className="phone-input-card">
                    <PhoneInput
                      country={"us"}
                      enableSearch={true}
                      value={phoneValue}
                      onChange={(val) => setPhoneValue(val)}
                      inputProps={{ name: "phone" }}
                    />
                    {phoneRequiredMessage && <p className="upgrade-fail-msg">{phoneRequiredMessage}</p>}
                    <button type="button" className="auth-submit-btn" onClick={updatePhoneAndRetry}>
                      <Translate textKey={"update"} />
                    </button>
                  </div>
                )}

                {/* {hasExistingSubscription && (
                  <button type="button" className="auth-submit-btn" onClick={switchToAnotherAccount}>
                    <Translate textKey="sign_in" />
                  </button>
                )} */}
              </>
            )}
          </div>
        </div>
      );
    }

    return (
      <div className={`auth-widget-card ${isRental ? "rental-auth-widget-adjust" : ""}`}>
        <div className="auth-tabs">
          <button className={`tab-btn ${authTab === "register" ? "active" : ""}`} onClick={() => setAuthTab("register")}>
            <Translate textKey="create_account" />
          </button>
          <button className={`tab-btn ${authTab === "login" ? "active" : ""}`} onClick={() => setAuthTab("login")}>
            <Translate textKey="sign_in" />
          </button>
        </div>

        {authTab === "register" ? (
          <div className="tab-pane">
            <div className="auth-pane-header">
              {!isRental && <div className="user-icon-circle">
                <UserIcon />
              </div>}
              <h3><Translate textKey="create_your_account" /></h3>
              {isRental ? <p className="subtitle">One quick step before your rental — no subscription required.</p> : <p className="subtitle">{selectedCheckoutPlan?.description}</p>}


            </div>

            {projectInfo?.projectConfig?.config?.GOOGLE_LOGIN_REQUIRED === "true" && projectInfo?.projectConfig?.config?.GOOGLE_CLIENT_ID && (
              <button className="google-auth-btn" onClick={() => googleLoginHandler()}>
                <GoogleIcon />
                <span><Translate textKey="google_sign_in" /></span>
              </button>
            )}

            {projectInfo?.projectConfig?.config?.APPLE_LOGIN_REQUIRED === "true" && projectInfo?.projectConfig?.config?.APPLE_CLIENT_ID && (
              <div className="apple-login-wrap">
                <div id="appleid-signin" data-color="black" data-border="true" data-type="sign in"></div>
              </div>
            )}

            <div className="form-divider">
              <span><Translate textKey="or_email" /></span>
            </div>

            <form onSubmit={handleAuthSubmit} className="auth-form">
              <div className="input-group">
                <input
                  type="email"
                  placeholder={translateText("email")}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onBlur={handleEmailCheck}
                  required
                />
              </div>

              <div className="input-group password-group">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder={translateText("password")}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <span className="eye-icon" onClick={() => setShowPassword(!showPassword)}>
                  <EyeIcon visible={showPassword} />
                </span>
              </div>

              <div className="input-group password-group">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder={translateText("confirm_password")}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
                <span className="eye-icon" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                  <EyeIcon visible={showConfirmPassword} />
                </span>
              </div>

              <button type="submit" className="auth-submit-btn" disabled={isProcessing}>
                {isProcessing ? <Translate textKey="processing" /> : (
                  selectedCheckoutPlan?.requires_payment === false || selectedCheckoutPlan?.subscription_id === 0 || selectedCheckoutPlan?.id === 0
                    ? <Translate textKey="start_free_plan" />
                    : <Translate textKey="start_free_trial" />
                )}
              </button>
            </form>

            <p className="privacy-terms-text">
              <Translate textKey="register_agree_text" />{" "}
              <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => navigate("/terms-and-conditions")}>
                <Translate textKey="terms_of_use" />
              </span>{" "}
              <Translate textKey="and" />{" "}
              <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => navigate("/privacy-policy")}>
                <Translate textKey="privacy_policy" />
              </span>
            </p>
          </div>
        ) : (
          <div className="tab-pane">
            <div className="auth-pane-header">
              {!isRental && <div className="user-icon-circle">
                <UserIcon />
              </div>}
              <h3><Translate textKey="sign_in_title" /></h3>

              {isRental ? <p className="subtitle">Sign in to pick up right where you left off.</p> : <p className="subtitle"><Translate textKey="signin_complete_catalog" /></p>}


            </div>

            {projectInfo?.projectConfig?.config?.GOOGLE_LOGIN_REQUIRED === "true" && projectInfo?.projectConfig?.config?.GOOGLE_CLIENT_ID && (
              <button className="google-auth-btn" onClick={() => googleLoginHandler()}>
                <GoogleIcon />
                <span><Translate textKey="google_sign_in" /></span>
              </button>
            )}

            {projectInfo?.projectConfig?.config?.APPLE_LOGIN_REQUIRED === "true" && projectInfo?.projectConfig?.config?.APPLE_CLIENT_ID && (
              <div className="apple-login-wrap">
                <div id="appleid-signin" data-color="black" data-border="true" data-type="sign in"></div>
              </div>
            )}

            {projectInfo?.projectConfig?.config?.LOGIN_WITH_MAGIC_LINK_REQUIRED === "true" && (
              <button type="button" className="google-auth-btn magic-link-btn" onClick={() => {
                localStorage.setItem('redirectFromNewCheckoutPage', 'true');
                setEmailLoginModal(true);
              }}>
                <span><Translate textKey="sign_in_via_email_password" /></span>
              </button>
            )}

            <div className="form-divider">
              <span><Translate textKey="or_email" /></span>
            </div>

            <form onSubmit={handleAuthSubmit} className="auth-form">
              <div className="input-group">
                <input
                  type="email"
                  placeholder={translateText("email")}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onBlur={handleEmailCheck}
                  required
                />
              </div>

              <div className="input-group password-group">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder={translateText("password")}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <span className="eye-icon" onClick={() => setShowPassword(!showPassword)}>
                  <EyeIcon visible={showPassword} />
                </span>
              </div>

              <button type="submit" className="auth-submit-btn" disabled={isProcessing}>
                {isProcessing ? <Translate textKey="processing" /> : <Translate textKey="sign_in" />}
              </button>
            </form>

            {projectInfo?.projectConfig?.config?.CUSTOM_LOGIN_SCREEN_MESSAGE && (
              <p className="custom-login-screen-message">{projectInfo.projectConfig.config.CUSTOM_LOGIN_SCREEN_MESSAGE}</p>
            )}

            <div className="forgot-password-link">
              <a href="/forgot-password"><Translate textKey="forgot_password" /></a>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="checkout-3-page">
      <ToastContainer />

      {otpModal && (
        <OtpModal
          appInfo={appInfo}
          userRegisterId={userRegisterId}
          setOtpModal={setOtpModal}
          tokenAuthenticate={tokenAuthenticate}
          updateDeviceAnalytics={updateDeviceAnalytics}
          values={checkoutValues}
          urlToRedirect={redirectUrl}
          onOtpSuccess={() => {
            setOtpModal(false);
            if (otpTriggeredBy === "login") {
              window.location.replace(redirectUrl || "/home");
              return;
            }
            if (selectedCheckoutPlan) {
              handleProceedPaymentForPlan(selectedCheckoutPlan);
            } else {
              navigate(redirectUrl, { replace: true });
            }
          }}
        />
      )}

      {showSocialLoginModal && (
        <SocialAccountLoginModal
          setShowSocialLoginModal={setShowSocialLoginModal}
          modalType={socialLoginModalType}
        />
      )}

      {emailLoginModal && (
        <LoginModal isEmailForm={emailLoginModal} setEmailLoginModal={setEmailLoginModal} tvCode={location?.state?.code} />
      )}

      {applePrivateLogin && (
        <ApplePrivateLoginModal
          isEmailForm={applePrivateLogin}
          setApplePrivateLogin={setApplePrivateLogin}
          setApplePrivateEmail={setApplePrivateEmail}
        />
      )}

      <div className="plans-page-content-wrapper">
        {!isVideoContext && <div className="table-header-box" style={hidePlans ? { display: "none" } : {}}>
          <span className="subtitle"><Translate textKey="checkout_title" /></span>
          <h1 className="title"><Translate textKey="checkout_subtitle" /></h1>
        </div>}

        <div className="split-layout-container">
          {!isRental && <div className="left-panel-table" style={hidePlans ? { display: "none" } : {}}>
            {renderPlansTable()}
          </div>}
          <div className="split-layout-divider" style={{ width: "2px", backgroundColor: "#222", margin: "0 20px" }}></div>
          <div className={`right-panel-auth ${isVideoContext && isRental ? "video-context" : ""}`}>
            {isVideoContext && isRental &&
              <div className="plans-table-card video-plan-card">
                {rentalCheckoutDetails?.logo && (
                  <div className="rental-header-logo-wrap">
                    <img
                      src={rentalCheckoutDetails?.logo}
                      alt={rentalCheckoutDetails?.rental_checkout_show_name || 'Show Logo'}
                      className="rental-header-logo-img"
                    />
                  </div>
                )}
                {rentalCheckoutDetails?.rental_checkout_show_name && (
                  <h2 className="rental-header-title">
                    {rentalCheckoutDetails?.rental_checkout_show_name}
                  </h2>
                )}
                <div data-dc-tpl="192" className="rental-preview-card">
                  <div data-dc-tpl="193" className="rental-preview-thumb">
                    <svg
                      data-dc-tpl="194"
                      className="rental-preview-icon"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#FF9B00"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path data-dc-tpl="195" d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"></path>
                      <circle data-dc-tpl="196" cx="12" cy="12" r="3"></circle>
                    </svg>
                  </div>
                  <div data-dc-tpl="197" className="rental-preview-body">
                    <div data-dc-tpl="198" className="rental-preview-title">
                      So you can watch <strong data-dc-tpl="199" className="rental-preview-title-strong">{rentalCheckoutDetails?.rental_checkout_show_name || 'Video'}</strong>
                    </div>
                    <div data-dc-tpl="200" className="rental-preview-meta">
                      <span className="sc-interp">{rentalCheckoutDetails?.rental_checkout_text || ''}</span>
                    </div>
                  </div>
                </div>
              </div>
            }
            {renderAuthWidget()}

            {hasSelectedCheckoutPlan && selectedCheckoutPlan?.requires_payment !== false && selectedCheckoutPlan?.subscription_id !== 0 && !isUpgradeFlow && !(authTab === "login" && !isRealUser) && (
              <div className="coupon-card">
                <div className="coupon-link" onClick={() => setHaveCoupon(prev => !prev)}>
                  <input
                    type="checkbox"
                    className="coupon-check"
                    checked={haveCoupon}
                    onChange={() => setHaveCoupon(prev => !prev)}
                    onClick={(e) => e.stopPropagation()}
                  />
                  <span>
                    <Translate textKey="having_coupon" />
                  </span>
                </div>

                {haveCoupon && (
                  <div className="coupon-section">
                    <input
                      type="text"
                      placeholder={translateText("enter_coupon_code")}
                      value={couponCode?.couponCode || ""}
                      onChange={(e) => {
                        setCouponError("");
                        setCouponCode(prev => ({ ...prev, couponCode: e.target.value }));
                      }}
                    />
                    <button
                      onClick={applyCouponCodeHandler}
                      disabled={couponProcessing}
                    >
                      {couponProcessing ? <Translate textKey="processing" /> : <Translate textKey="apply" />}
                    </button>
                  </div>
                )}

                {haveCoupon && couponError && <p className="error">{couponError}</p>}
                {haveCoupon && couponSuccess && <p className="success"><Translate textKey="coupon_success_message" /></p>}
              </div>
            )}
          </div>
        </div>
      </div>

      {showUpgradeConfirm && (
        <div className="upgrade-confirm-modal">
          <div className="overlay" onClick={() => !upgradeProcessing && setShowUpgradeConfirm(false)}></div>
          <div className="modal-card">
            <h3><Translate textKey="payment_confirm" /></h3>
            <div className="amount-row">
              <span>{upgradeInvoiceDetails?.description?.plan_amount}</span>
              <strong>{upgradeInvoiceDetails?.plan}</strong>
            </div>
            <div className="amount-row">
              <span>{upgradeInvoiceDetails?.description?.unused_time}</span>
              <strong>{upgradeInvoiceDetails?.discount}</strong>
            </div>
            <div className="amount-row total">
              <span>{upgradeInvoiceDetails?.description?.amount_due}</span>
              <strong>{upgradeInvoiceDetails?.due}</strong>
            </div>
            <div className="action-row">
              <button
                type="button"
                className="cancel-btn"
                onClick={() => setShowUpgradeConfirm(false)}
                disabled={upgradeProcessing}
              >
                <Translate textKey="cancel" />
              </button>
              <button
                type="button"
                className="confirm-btn"
                onClick={confirmUpgrade}
                disabled={upgradeProcessing}
              >
                {upgradeProcessing ? <Translate textKey="processing" /> : <Translate textKey="update" />}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Checkout3;
